import { onMounted, onUnmounted } from 'vue';

const HTML_FIT_CLASS = 'b2b-page-fit';

export function useB2bPageFit() {
  onMounted(() => {
    document.documentElement.classList.add(HTML_FIT_CLASS);
  });

  onUnmounted(() => {
    document.documentElement.classList.remove(HTML_FIT_CLASS);
  });
}
